import { render, staticRenderFns } from "./SetupEdit.vue?vue&type=template&id=5a13b891&scoped=true&"
import script from "./SetupEdit.vue?vue&type=script&lang=js&"
export * from "./SetupEdit.vue?vue&type=script&lang=js&"
import style0 from "./SetupEdit.vue?vue&type=style&index=0&id=5a13b891&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a13b891",
  null
  
)

export default component.exports